import { isElementNode } from 'anodum';
import setCaretInTheEndOfNode from './set-caret-in-the-end-of-node';
import splitElementByCollapsedSelection from './split-element-by-collapsed-selection';

const splitElementByTheEndOfNode = (element) => {
  if (!isElementNode(element)) return;

  setCaretInTheEndOfNode(element);
  splitElementByCollapsedSelection(element);
};

export default splitElementByTheEndOfNode;
